<template>
    <div v-show="(itemType == 'inquiry') || showExpiryDate">

        <div class="row labelContainer">
            <div class="col-md-3 col-xs-4">
                <label class="">Requires Follow Up?</label>
            </div>

            <div class="col-md-9 col-xs-8">
                <div class="material-switch ">
                    <input id="is_to_follow"
                           autocomplete="off"
                           name="is_to_follow"
                           v-model="toFollow"
                           type="checkbox"
                           @change="changeFollowUp">
                    <label class="label-default" for="is_to_follow">

                    </label>

                </div>
            </div>
        </div>
        <div class="row labelContainer"  v-show="toFollow == 1">
            <div class="col-md-3 col-xs-4">
                <label class=""> Follow Up Date </label>
            </div>
            <div class="col-md-9 col-xs-8">
                <div id="followUpDatePicker" class="input-group date">
                        <span class="input-group-addon">
                            <i class="fa fa-calendar"></i>
                        </span>
                    <input ref="followDate" id="followUpDate" v-model="toFollowDate" autocomplete="off"  class="date text_input form-control"
                           :name="toFollowDateName" type="text">
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import {changeFollowUp,updateFollowUpDate,getAvailableForms, changeFollowUpForInquiry, updateFollowUpDateForInquiry,changeExpiryDate,updateExpiryDate} from "@/modules/Forms/api"

export default {
    name: "ToFollow",
    props: {
        isToFollow : 0,
        toFollowDate : '',
        itemId : 0,
        itemType : '',
        viewPage : false,
        dateFormat: {
            required: true,
            type: String
        },
        bookingStatus:0,
        isInquiry:false,
    },
    data() {
        return {
            toFollow : this.isToFollow
        }
    },
    components: {

    },
    computed: {
        showExpiryDate(){
            if (this.bookingStatus == 3 ){
                return true;
            }
            else {
                return false;
            }
        },
        toFollowDateName(){
            if (this.isInquiry){
                return 'deferred_date';
            }
            else {
                return 'to_follow';
            }
        }
    },
    methods: {
        initializeFollowUpDatePickerForInquiry() {
            const vm = this;
            $(this.$refs['followDate']).datepicker({
                todayBtn: "linked",
                todayHighlight: true,
                keyboardNavigation: false,
                forceParse: false,
                calendarWeeks: true,
                autoclose: true,
                format: vm.dateFormat
                // Your datepicker options here
            }).on('changeDate', function(e) {
                vm.followUpDateValue = e.target.value;
                if (e.target.id === "followUpDate"){
                    vm.updateFollowUpDate(e.target.value);
                }
            });
            // Add any additional logic if needed
        },
        updateFollowUpDate(value){
            let vm = this
            let url = '/follow-up'+ '/' + this.itemId+'?type=inquiry';
            if(vm.itemType == 'inquiry'){
                if(vm.viewPage){
                    updateFollowUpDateForInquiry(this.itemId,value).then(response => {
                        if (response.status){
                            $.notify('Follow up date has been updated successfully', 'success')
                        }
                    })
                }
            }else{
                if(vm.viewPage) {
                    updateFollowUpDate(this.itemId, value).then(response => {
                        if (response.status) {
                            $.notify('Follow up date has been updated successfully', 'success')
                        }
                    })
                }
            }

        },
        changeFollowUp(){
            let vm =this;
            if(vm.itemType == 'inquiry'){
                if(vm.viewPage){
                    changeFollowUpForInquiry(vm.itemId , vm.toFollow).then(response => {
                        if (response.status){
                            $.notify('Follow up date has been changed successfully', 'success')
                        }
                    })
                }
            }else{
                if(this.viewPage){
                    let toFollowValue = !vm.toFollow;
                    changeFollowUp(vm.itemId , toFollowValue).then(response => {
                        if (response.status){
                            $.notify('Follow up date has been changed successfully', 'success')
                        }
                    })
                }
            }

        },
    },
    mounted() {
      if (!this.itemId){
        this.toFollow = true;
      }
        this.$nextTick(() => {
            let vm = this;
            setTimeout(function (e){
                if(vm.toFollow == "0"){
                    $("#is_to_follow").prop("checked", false)
                }
                vm.initializeFollowUpDatePickerForInquiry();
            },2000)

        })
    },
    created() {

    }

}
</script>

<style scoped>
.selected {
    font-weight: bold;
}
#followUpDatePicker{
    //width: 35%;
}
#followUpDatePicker span{
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px !important;
}

#followUpDate{
    border-top-right-radius: 15px !important;
    border-bottom-right-radius: 15px !important;
}

.material-switch{
    width: 50px;
    float: left;
}
.immediately_class{
    float: left;
}

@media (max-width: 767px) {
    #followUpDatePicker{
        width: 100%;
    }
}

</style>